"use client";

import { useDeferUntilInteraction } from "@/hooks/useDeferUntilInteraction";

/**
 * Google Analytics (gtag.js) — deferred until the visitor actually engages
 * with the page. `strategy="lazyOnload"` still fires on the window `load`
 * event, which lands inside Lighthouse's interactivity window and produced
 * long tasks that kept "Time to Interactive" from ever finding a quiet
 * window. Analytics doesn't need to be ready before a visitor has done
 * anything on the page.
 */
export default function DeferredAnalytics({ measurementId }: { measurementId: string }) {
  useDeferUntilInteraction(() => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", measurementId);

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);
  }, 18_000);

  return null;
}

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}
